<ion-content>
  <div class="message-and-tags">
    <app-message-in-task-process [message]="task" [taskProcessContext]="taskProcessContext">
    </app-message-in-task-process>
    <app-select-tags *ngIf="tagsContext && !isCRMMode && !isUserReadOnly" [tagsContext]="tagsContext"></app-select-tags>
  </div>
  <div class="separator"></div>

  <ion-item *ngIf="externalUrl" lines="none" detail="false" [href]="externalUrl" target="_blank" class="external-url">
    <span class="alc-text-nowrap">
      <span class="link-color">{{ 'm/task-process/task-actions-link' | translate }}</span>
      <app-site-icon-and-name [site]="site"></app-site-icon-and-name>
    </span>
    <ion-icon slot="end" name="open-outline" class="open-external-icon"></ion-icon>
  </ion-item>

  <ion-item lines="none" detail="false" *ngIf="$any(taskProcessContext.site).openStatusTranslation">
    <ion-chip class="open-status" [ngClass]="$any(taskProcessContext.site).openStatusColor">
      {{ $any(taskProcessContext.site).openStatusTranslation }}
    </ion-chip>
  </ion-item>

  <div class="separator" *ngIf="externalUrl || $any(taskProcessContext.site).openStatusTranslation"></div>

  <ion-item
    *ngIf="shouldShowProcessThisMessageButton() && !isUserReadOnly"
    (click)="maybeConfirmThenProcessThisTask()"
    [disabled]="isProcessThisMessageButtonDisabled"
    button
    lines="full">
    <span class="link-color">{{ processThisTaskLabelKey() | translate }}</span>
    <ion-icon *ngIf="isProcessThisTaskInNewTab()" slot="end" name="open-outline" class="open-external-icon"></ion-icon>
  </ion-item>
  <ion-item
    *ngIf="shouldShowRouteButton() && !isUserReadOnly"
    (click)="onRouteClicked($event)"
    button
    lines="full"
    detail="false">
    <span class="link-color">{{ 'm/task-process/tooltips/route' | translate }}</span>
  </ion-item>

  <ion-item lines="none">
    <ion-label class="audit-log-title">{{ 'm/task-process/task-actions-audit-title' | translate }}</ion-label>
  </ion-item>

  <div class="timeline">
    <ion-spinner *ngIf="!actions"></ion-spinner>
    <ul *ngIf="!!actions">
      <ng-container *ngIf="receivedMsgLogEntry">
        <li>
          <div class="bullet-and-time-and-text date-container">
            <div class="bullet light-blue"></div>
            <div class="date" [matTooltip]="receivedMsgLogEntry.datetime | dateTimezone: 'fullDate'">
              {{ receivedMsgLogEntry.datetime | dateTimezone: receivedMsgLogEntry.dayIndicatorFormat }}
            </div>
          </div>
        </li>
        <li>
          <div class="bullet-and-time-and-text">
            <div class="bullet blue"></div>
            <div class="time" [matTooltip]="receivedMsgLogEntry.datetime | dateTimezone: 'medium'">
              {{ receivedMsgLogEntry.datetime | dateTimezone: 'shortTime' }}
            </div>
            <div class="text">
              {{ receivedMsgLogEntry.translatedText }}
              <div>
                <app-avatar class="avatar" [src]="receivedMsgLogEntry.from.avatarURL"></app-avatar>
                <span class="sender-name"
                  >{{ receivedMsgLogEntry.from.name }}
                  <app-vip-bullet *ngIf="receivedMsgLogEntry.from.isVIP"></app-vip-bullet>
                </span>
              </div>
            </div>
          </div>
        </li>
      </ng-container>
      <ng-container *ngFor="let action of actions">
        <li *ngIf="action.dayIndicatorFormat">
          <div class="bullet-and-time-and-text date-container">
            <div class="bullet light-blue"></div>
            <div class="date" [matTooltip]="receivedMsgLogEntry.datetime | dateTimezone: 'fullDate'">
              {{ action.datetime | dateTimezone: action.dayIndicatorFormat }}
            </div>
          </div>
        </li>
        <li>
          <div class="bullet-and-time-and-text">
            <div class="bullet blue"></div>
            <div class="time" [matTooltip]="action.datetime | dateTimezone: 'medium'">
              {{ action.datetime | dateTimezone: 'shortTime' }}
            </div>
            <div *ngIf="!shouldDisplayTextWithLinkToRule(action)" class="text">
              {{ action.translatedText + (action.extraTranslatedText ? action.extraTranslatedText : '') }}
            </div>
            <div *ngIf="shouldDisplayTextWithLinkToRule(action)" class="text">
              {{ action.translatedText }}
              <a (click)="goToTriageRule(action)" class="text">
                {{ action.extraTranslatedText }}
              </a>
            </div>
          </div>
          <app-message-in-task-process
            *ngIf="isAnswerOrAnnotationOrHelpAction(action)"
            [message]="action"
            [taskProcessContext]="taskProcessContext">
          </app-message-in-task-process>
          <app-message-in-task-process
            *ngIf="action.updatedTask"
            [message]="action.updatedTask"
            [taskProcessContext]="taskProcessContext">
          </app-message-in-task-process>
          <div *ngIf="action.firstAnswerByHumanDelays" class="delays-grid">
            <ng-container *ngIf="action.firstAnswerByHumanDelays.raw">
              <div>{{ 'm/task-process/task-actions-log/delays/raw' | translate }} :</div>
              <div>
                <span
                  *ngFor="let vau of action.firstAnswerByHumanDelays.raw"
                  [appValueAndUnit]="vau"
                  [alcIsShort]="true"
                  [alcIsNoSpace]="true"></span>
              </div>
            </ng-container>
            <ng-container *ngIf="action.firstAnswerByHumanDelays.businessHours">
              <div>{{ 'm/task-process/task-actions-log/delays/bo' | translate }} :</div>
              <div>
                <span
                  *ngFor="let vau of action.firstAnswerByHumanDelays.businessHours"
                  [appValueAndUnit]="vau"
                  [alcIsShort]="true"
                  [alcIsNoSpace]="true"></span>
              </div>
            </ng-container>
          </div>
        </li>
      </ng-container>
    </ul>
  </div>
</ion-content>
<!-- hidden tag select that will be triggered to select a team -->
<app-select-tag
  *ngIf="routingTagGroup"
  #selectRoutingTag
  [group]="routingTagGroup"
  [tagsContext]="tagsContext"
  class="hidden"></app-select-tag>
